module.exports = __webpack_public_path__ + "img/horizontal_4_7_7005.17a643d8.png";